import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// Persistent atoms - these will survive page refreshes
export const seeTaturialOneTimeAtom = atomWithStorage(
  "seeTutorialOneTime",
  false
);
export const globalCommunity = atomWithStorage("globalCommunity", []);
export const globalBusinessName = atomWithStorage("globalBusinessName", "");
// Use sessionStorage instead of localStorage to prevent cross-tab interference
// sessionStorage is tab-specific: each tab has its own storage
// This prevents titles from one tab appearing in another tab
export const globalCurrentPageTitle = atomWithStorage(
  "globalCurrentPageTitle",
  "",
  sessionStorage // Each tab has its own sessionStorage - no cross-tab interference
);
export const activeTutorialScreen=atomWithStorage("activeTutorialScreen",{
  activeTurial:null,
  purposeOfJoining:""
});
export const globalAllLeaderCommunities = atomWithStorage(
  "globalAllLeaderCommunities",
  []
);
export const showBalance = atomWithStorage("showBalance", false);

export const selectedRowsforVerifyMyTrade = atomWithStorage(
  "selectedRowsforVerifyMyTrade",
  []
);

// Add persistent atom for showTable
export const showTableAtom = atomWithStorage(
  "showTable",
  "closed"
);

// Add persistent atom for selectedOptionForOtp
export const selectedOptionForOtpAtom = atomWithStorage(
  "selectedOptionForOtp",
  null
);

// Add persistent atom for paymentType
export const paymentTypeAtom = atomWithStorage("paymentType", null);

// UI state atoms
export const showPayoutDetailsAtom = atomWithStorage(
  "showPayoutDetails",
  false
);

export const showTradeNameAtom = atomWithStorage("showTradeName", false);

// Custom persistent atom creator for advanced use cases
export const createPersistentAtom = (key, defaultValue, options = {}) => {
  const {
    storage = localStorage,
    serialize = JSON.stringify,
    deserialize = JSON.parse,
    skipHydration = false,
  } = options;

  const baseAtom = atom(defaultValue);

  // Derived atom that handles persistence
  const persistentAtom = atom(
    (get) => get(baseAtom),
    (get, set, newValue) => {
      set(baseAtom, newValue);

      try {
        if (newValue === null || newValue === undefined) {
          storage.removeItem(key);
        } else {
          storage.setItem(key, serialize(newValue));
        }
      } catch (error) {
        console.warn(`Failed to persist atom ${key}:`, error);
      }
    }
  );

  // Initialize from storage on first read
  if (!skipHydration) {
    try {
      const stored = storage.getItem(key);
      if (stored !== null) {
        const parsed = deserialize(stored);
        baseAtom.init = parsed;
      }
    } catch (error) {
      console.warn(`Failed to hydrate atom ${key}:`, error);
    }
  }

  return persistentAtom;
};

// Example usage of custom persistent atom with session storage
export const sessionDataAtom = createPersistentAtom(
  "sessionData",
  {},
  {
    storage: sessionStorage,
    serialize: (value) => JSON.stringify(value),
    deserialize: (value) => JSON.parse(value),
  }
);
